<!-- qa搜索模块 -->
<!-- 引入这个模块需要有pagedata -->
<template>
  <div class="searchModelBody">
    <div class="searchBox">
      <h1>{{ heroTitle }}</h1>
      <div class="searchBoxCon">
        <el-popover
          popper-class="qasearchHistoryBox"
          placement="bottom"
          trigger="manual"
          v-model="visible"
        >
          <ul class="searchHistory">
            <li
              v-for="(item, index) in showSearchList"
              :key="index"
              @click="searchStr = item.text"
            >
              {{ item.text }}
            </li>
          </ul>
          <input
            v-model="searchStr"
            slot="reference"
            type="text"
            @focus="showSearchList.length ? (visible = true) : ''"
            @focusout="visible = false"
            @input="piPei"
            @keydown.enter.prevent="toResultsPage"
            :placeholder="placeholder"
          />
        </el-popover>
        <i
          v-if="!!searchStr"
          class="el-icon-circle-close clearInput"
          @click.prevent="searchStr = ''"
        ></i>
        <button @click.prevent="toResultsPage">
          <img
            src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260616094702959026.svg"
            alt=""
          />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import pageData from "../unitl/pageData";
import { getFaqLabel, searchFaqPages } from "../unitl/faqLocale";

export default {
  data() {
    return {
      searchStr: "",
      visible: false,
      showSearchList: [],
    };
  },
  computed: {
    pageData() {
      return this.$parent.pageData || pageData;
    },
    homePage() {
      return this.pageData.find((item) => item.router === "centro-de-ayuda") || {};
    },
    heroTitle() {
      return getFaqLabel(
        this.homePage.homeLabels,
        "heroTitle",
        this.$store.state.fanyi,
      );
    },
    placeholder() {
      return getFaqLabel(
        this.homePage.homeLabels,
        "placeholder",
        this.$store.state.fanyi,
      );
    },
  },
  created() {
    if (this.$route.query.s) {
      this.searchStr = decodeURIComponent(
        String(this.$route.query.s).replace(/\+/g, " "),
      );
    }
  },
  methods: {
    piPei() {
      this.showSearchList = [];
      this.$store.state.QASearchHistore.forEach((element) => {
        if (element.text.indexOf(this.searchStr.trim()) != -1) {
          this.showSearchList.unshift(element);
        }
      });
      this.showSearchList = this.showSearchList.slice(0, 6);
      this.visible = false;
      setTimeout(() => {
        if (this.showSearchList.length) {
          this.visible = true;
        }
      }, 100);
    },
    toResultsPage() {
      if (
        !this.$store.state.QASearchHistore.find((item) => {
          return item.text == this.searchStr.trim();
        })
      ) {
        this.$store.commit(
          "getQASearchHistore",
          this.$store.state.QASearchHistore.unshift({
            text: this.searchStr.trim(),
          }),
        );
      }
      this.$store.commit("getshowLoginDialog", false);
      const query = this.searchStr.trim();
      const jumpResults = searchFaqPages(this.pageData, query).length
        ? "resultado-de-busqueda"
        : "resultado-busqueda-no-encontrado";
      this.$fun.routerToPage(
        "/" + jumpResults + "?s=" + encodeURIComponent(query),
      );
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
.searchModelBody {
  margin-top: -20px;
  width: 100%;
  height: 276px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f2f6f7;
  .searchBox {
    h1 {
      text-align: center;
      padding-bottom: 45px;
      font-size: 26px;
      line-height: 30px;
      font-weight: bold;
    }
    .searchBoxCon {
      display: flex;
      position: relative;

      input {
        width: 700px;
        background-color: white;
        flex: 1;
        height: 65px;
        border: none;
        padding: 0 86px 0 21px;
        font-size: 15px;
        transform: 0.4s;
        border-radius: 6px;
        box-shadow: 0px 3px 4px -1px rgba(0, 0, 0, 0.14);
        &:focus {
          box-shadow: 0px 3px 12px -1px rgba(0, 0, 0, 0.14);
        }
      }

      .clearInput {
        position: absolute;
        right: 75px;
        top: 50%;
        transform: translateY(-50%);
        display: none;
        cursor: pointer;
        font-size: 18px;
        color: #67c23a;
      }
      &:hover .clearInput {
        display: block;
      }
      button {
        position: absolute;
        right: 0;
        height: 100%;
        width: 65px;
        background-color: transparent;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 17px;
          height: 18px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.qasearchHistoryBox {
  padding: 0;
  .searchHistory {
    min-width: 110px;
    max-width: 500px;

    li {
      line-height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 10px;
      cursor: pointer;
      &:hover {
        background-color: #e8e8e9;
      }
    }
  }
}
</style>
